var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"5"}},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.label)))])]),_c('v-col',{attrs:{"cols":"7"}},[_c('span',{class:`font-weight-medium line-break ${_vm.contentColor}`},[_vm._v(_vm._s(_vm.content))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }